// Group creation form translations
// Falls back to English for unsupported languages

const translations = {
  en: {
    groupName: 'Group Name',
    description: 'Description',
    groupCategory: 'Group Category *',
    selectCategory: '-- Select Group Category --',
    benevolence: 'Benevolence Group',
    tableBanking: 'Table Banking (ROSCAs)',
    sacco: 'SACCO',
    selfHelp: 'Self-help Group',
    investment: 'Investment Group',
    savings: 'Savings Group',
    community: 'Community Group',
    empowerment: 'Empowerment Group',
    categoryHint: 'Select the type of group you\'re creating',
    language: 'Language *',
    languageHint: 'Primary language for group communications',
    currency: 'Currency *',
    paymentAmount: 'Payment Amount',
    paymentFrequency: 'Payment Frequency',
    weekly: 'Weekly',
    monthly: 'Monthly',
    quarterly: 'Quarterly',
    onDemand: 'On Demand (As Needed)',
    subscriptionPlan: 'Subscription Plan',
    subscriptionHint: 'Select your subscription tier based on expected group size. You can always upgrade later.',
    subscriptionTier: 'Subscription Tier',
    tierAutoUpgrade: 'Auto-upgrades when membership exceeds tier limit',
    billingCycle: 'Billing Cycle',
    billedMonthly: 'Billed monthly',
    annual: 'Annual',
    save10: 'Save 10%',
    bestValue: 'Best Value',
    paymentMethod: 'Payment Method',
    creditCard: 'Credit/Debit Card',
    bankAccount: 'US Bank Account',
    createGroup: 'Create Group & Setup Payment',
    members: 'Members',
  },
  es: {
    groupName: 'Nombre del Grupo',
    description: 'Descripcion',
    groupCategory: 'Categoria del Grupo *',
    selectCategory: '-- Seleccionar Categoria --',
    benevolence: 'Grupo de Beneficencia',
    tableBanking: 'Banca de Mesa (ROSCAs)',
    sacco: 'SACCO',
    selfHelp: 'Grupo de Autoayuda',
    investment: 'Grupo de Inversion',
    savings: 'Grupo de Ahorro',
    community: 'Grupo Comunitario',
    empowerment: 'Grupo de Empoderamiento',
    categoryHint: 'Seleccione el tipo de grupo que esta creando',
    language: 'Idioma *',
    languageHint: 'Idioma principal para las comunicaciones del grupo',
    currency: 'Moneda *',
    paymentAmount: 'Monto del Pago',
    paymentFrequency: 'Frecuencia de Pago',
    weekly: 'Semanal',
    monthly: 'Mensual',
    quarterly: 'Trimestral',
    onDemand: 'Bajo Demanda',
    subscriptionPlan: 'Plan de Suscripcion',
    subscriptionHint: 'Seleccione su nivel segun el tamano esperado del grupo. Puede actualizar despues.',
    subscriptionTier: 'Nivel de Suscripcion',
    tierAutoUpgrade: 'Se actualiza automaticamente cuando la membresia excede el limite',
    billingCycle: 'Ciclo de Facturacion',
    billedMonthly: 'Facturado mensualmente',
    annual: 'Anual',
    save10: 'Ahorre 10%',
    bestValue: 'Mejor Valor',
    paymentMethod: 'Metodo de Pago',
    creditCard: 'Tarjeta de Credito/Debito',
    bankAccount: 'Cuenta Bancaria de EE.UU.',
    createGroup: 'Crear Grupo y Configurar Pago',
    members: 'Miembros',
  },
  fr: {
    groupName: 'Nom du Groupe',
    description: 'Description',
    groupCategory: 'Categorie du Groupe *',
    selectCategory: '-- Choisir une Categorie --',
    benevolence: 'Groupe de Bienfaisance',
    tableBanking: 'Tontine (ROSCAs)',
    sacco: 'SACCO',
    selfHelp: 'Groupe d\'Entraide',
    investment: 'Groupe d\'Investissement',
    savings: 'Groupe d\'Epargne',
    community: 'Groupe Communautaire',
    empowerment: 'Groupe d\'Autonomisation',
    categoryHint: 'Selectionnez le type de groupe que vous creez',
    language: 'Langue *',
    languageHint: 'Langue principale pour les communications du groupe',
    currency: 'Devise *',
    paymentAmount: 'Montant du Paiement',
    paymentFrequency: 'Frequence de Paiement',
    weekly: 'Hebdomadaire',
    monthly: 'Mensuel',
    quarterly: 'Trimestriel',
    onDemand: 'A la Demande',
    subscriptionPlan: 'Plan d\'Abonnement',
    subscriptionHint: 'Selectionnez votre niveau en fonction de la taille prevue du groupe.',
    subscriptionTier: 'Niveau d\'Abonnement',
    tierAutoUpgrade: 'Mise a niveau automatique lorsque l\'effectif depasse la limite',
    billingCycle: 'Cycle de Facturation',
    billedMonthly: 'Facture mensuellement',
    annual: 'Annuel',
    save10: 'Economisez 10%',
    bestValue: 'Meilleur Rapport',
    paymentMethod: 'Mode de Paiement',
    creditCard: 'Carte de Credit/Debit',
    bankAccount: 'Compte Bancaire US',
    createGroup: 'Creer le Groupe et Configurer le Paiement',
    members: 'Membres',
  },
  pt: {
    groupName: 'Nome do Grupo',
    description: 'Descricao',
    groupCategory: 'Categoria do Grupo *',
    selectCategory: '-- Selecionar Categoria --',
    benevolence: 'Grupo de Beneficencia',
    tableBanking: 'Mesa de Credito (ROSCAs)',
    sacco: 'SACCO',
    selfHelp: 'Grupo de Auto-ajuda',
    investment: 'Grupo de Investimento',
    savings: 'Grupo de Poupanca',
    community: 'Grupo Comunitario',
    empowerment: 'Grupo de Capacitacao',
    categoryHint: 'Selecione o tipo de grupo que esta criando',
    language: 'Idioma *',
    languageHint: 'Idioma principal para comunicacoes do grupo',
    currency: 'Moeda *',
    paymentAmount: 'Valor do Pagamento',
    paymentFrequency: 'Frequencia de Pagamento',
    weekly: 'Semanal',
    monthly: 'Mensal',
    quarterly: 'Trimestral',
    onDemand: 'Sob Demanda',
    subscriptionPlan: 'Plano de Assinatura',
    subscriptionHint: 'Selecione seu nivel com base no tamanho esperado do grupo.',
    subscriptionTier: 'Nivel de Assinatura',
    tierAutoUpgrade: 'Atualiza automaticamente quando a associacao excede o limite',
    billingCycle: 'Ciclo de Faturamento',
    billedMonthly: 'Cobrado mensalmente',
    annual: 'Anual',
    save10: 'Economize 10%',
    bestValue: 'Melhor Valor',
    paymentMethod: 'Metodo de Pagamento',
    creditCard: 'Cartao de Credito/Debito',
    bankAccount: 'Conta Bancaria dos EUA',
    createGroup: 'Criar Grupo e Configurar Pagamento',
    members: 'Membros',
  },
  sw: {
    groupName: 'Jina la Kikundi',
    description: 'Maelezo',
    groupCategory: 'Aina ya Kikundi *',
    selectCategory: '-- Chagua Aina ya Kikundi --',
    benevolence: 'Kikundi cha Hisani',
    tableBanking: 'Benki ya Meza (Chama)',
    sacco: 'SACCO',
    selfHelp: 'Kikundi cha Kujisaidia',
    investment: 'Kikundi cha Uwekezaji',
    savings: 'Kikundi cha Akiba',
    community: 'Kikundi cha Jamii',
    empowerment: 'Kikundi cha Uwezeshaji',
    categoryHint: 'Chagua aina ya kikundi unachounda',
    language: 'Lugha *',
    languageHint: 'Lugha kuu ya mawasiliano ya kikundi',
    currency: 'Sarafu *',
    paymentAmount: 'Kiasi cha Malipo',
    paymentFrequency: 'Mzunguko wa Malipo',
    weekly: 'Kila Wiki',
    monthly: 'Kila Mwezi',
    quarterly: 'Kila Robo Mwaka',
    onDemand: 'Kwa Mahitaji',
    subscriptionPlan: 'Mpango wa Usajili',
    subscriptionHint: 'Chagua kiwango chako kulingana na ukubwa unaotarajia wa kikundi.',
    subscriptionTier: 'Kiwango cha Usajili',
    tierAutoUpgrade: 'Inasasishwa kiotomatiki wanachama wanapozidi kikomo',
    billingCycle: 'Mzunguko wa Bili',
    billedMonthly: 'Hulipishwa kila mwezi',
    annual: 'Kwa Mwaka',
    save10: 'Okoa 10%',
    bestValue: 'Thamani Bora',
    paymentMethod: 'Njia ya Malipo',
    creditCard: 'Kadi ya Mikopo/Debiti',
    bankAccount: 'Akaunti ya Benki ya Marekani',
    createGroup: 'Unda Kikundi na Weka Malipo',
    members: 'Wanachama',
  },
  ar: {
    groupName: 'اسم المجموعة',
    description: 'الوصف',
    groupCategory: '* فئة المجموعة',
    selectCategory: '-- اختر فئة المجموعة --',
    benevolence: 'مجموعة خيرية',
    tableBanking: 'بنك الطاولة',
    sacco: 'ساكو',
    selfHelp: 'مجموعة مساعدة ذاتية',
    investment: 'مجموعة استثمارية',
    savings: 'مجموعة ادخار',
    community: 'مجموعة مجتمعية',
    empowerment: 'مجموعة تمكين',
    categoryHint: 'اختر نوع المجموعة التي تنشئها',
    language: '* اللغة',
    languageHint: 'اللغة الرئيسية لاتصالات المجموعة',
    currency: '* العملة',
    paymentAmount: 'مبلغ الدفع',
    paymentFrequency: 'تكرار الدفع',
    weekly: 'اسبوعي',
    monthly: 'شهري',
    quarterly: 'ربع سنوي',
    onDemand: 'حسب الطلب',
    subscriptionPlan: 'خطة الاشتراك',
    subscriptionHint: 'اختر مستوى اشتراكك بناء على حجم المجموعة المتوقع',
    subscriptionTier: 'مستوى الاشتراك',
    tierAutoUpgrade: 'يتم الترقية تلقائيا عند تجاوز حد العضوية',
    billingCycle: 'دورة الفوترة',
    billedMonthly: 'يتم الفوترة شهريا',
    annual: 'سنوي',
    save10: 'وفر 10%',
    bestValue: 'افضل قيمة',
    paymentMethod: 'طريقة الدفع',
    creditCard: 'بطاقة ائتمان/خصم',
    bankAccount: 'حساب بنكي امريكي',
    createGroup: 'إنشاء المجموعة وإعداد الدفع',
    members: 'اعضاء',
  },
  zh: {
    groupName: '群组名称',
    description: '描述',
    groupCategory: '群组类别 *',
    selectCategory: '-- 选择群组类别 --',
    benevolence: '慈善团体',
    tableBanking: '互助储蓄会',
    sacco: '储蓄合作社',
    selfHelp: '自助团体',
    investment: '投资团体',
    savings: '储蓄团体',
    community: '社区团体',
    empowerment: '赋权团体',
    categoryHint: '选择您要创建的群组类型',
    language: '语言 *',
    languageHint: '群组通讯的主要语言',
    currency: '货币 *',
    paymentAmount: '付款金额',
    paymentFrequency: '付款频率',
    weekly: '每周',
    monthly: '每月',
    quarterly: '每季度',
    onDemand: '按需',
    subscriptionPlan: '订阅计划',
    subscriptionHint: '根据预期群组规模选择订阅级别。您可以随时升级。',
    subscriptionTier: '订阅级别',
    tierAutoUpgrade: '成员超过限制时自动升级',
    billingCycle: '计费周期',
    billedMonthly: '按月计费',
    annual: '年度',
    save10: '节省10%',
    bestValue: '最佳价值',
    paymentMethod: '付款方式',
    creditCard: '信用卡/借记卡',
    bankAccount: '美国银行账户',
    createGroup: '创建群组并设置付款',
    members: '成员',
  },
  hi: {
    groupName: 'समूह का नाम',
    description: 'विवरण',
    groupCategory: 'समूह श्रेणी *',
    selectCategory: '-- समूह श्रेणी चुनें --',
    benevolence: 'परोपकार समूह',
    tableBanking: 'टेबल बैंकिंग',
    sacco: 'सैको',
    selfHelp: 'स्व-सहायता समूह',
    investment: 'निवेश समूह',
    savings: 'बचत समूह',
    community: 'सामुदायिक समूह',
    empowerment: 'सशक्तिकरण समूह',
    categoryHint: 'आप जिस प्रकार का समूह बना रहे हैं उसे चुनें',
    language: 'भाषा *',
    languageHint: 'समूह संचार की प्राथमिक भाषा',
    currency: 'मुद्रा *',
    paymentAmount: 'भुगतान राशि',
    paymentFrequency: 'भुगतान आवृत्ति',
    weekly: 'साप्ताहिक',
    monthly: 'मासिक',
    quarterly: 'त्रैमासिक',
    onDemand: 'मांग पर',
    subscriptionPlan: 'सदस्यता योजना',
    subscriptionHint: 'अपेक्षित समूह आकार के आधार पर अपना स्तर चुनें।',
    subscriptionTier: 'सदस्यता स्तर',
    tierAutoUpgrade: 'सदस्यता सीमा पार होने पर स्वतः अपग्रेड',
    billingCycle: 'बिलिंग चक्र',
    billedMonthly: 'मासिक बिल',
    annual: 'वार्षिक',
    save10: '10% बचाएं',
    bestValue: 'सर्वश्रेष्ठ मूल्य',
    paymentMethod: 'भुगतान विधि',
    creditCard: 'क्रेडिट/डेबिट कार्ड',
    bankAccount: 'अमेरिकी बैंक खाता',
    createGroup: 'समूह बनाएं और भुगतान सेट करें',
    members: 'सदस्य',
  },
  de: {
    groupName: 'Gruppenname',
    description: 'Beschreibung',
    groupCategory: 'Gruppenkategorie *',
    selectCategory: '-- Kategorie wahlen --',
    benevolence: 'Wohltaetigkeitsgruppe',
    tableBanking: 'Tisch-Banking (ROSCAs)',
    sacco: 'SACCO',
    selfHelp: 'Selbsthilfegruppe',
    investment: 'Investmentgruppe',
    savings: 'Spargruppe',
    community: 'Gemeinschaftsgruppe',
    empowerment: 'Foerdergruppe',
    categoryHint: 'Wahlen Sie den Typ der Gruppe, die Sie erstellen',
    language: 'Sprache *',
    languageHint: 'Hauptsprache fuer Gruppenkommunikation',
    currency: 'Waehrung *',
    paymentAmount: 'Zahlungsbetrag',
    paymentFrequency: 'Zahlungshaeufigkeit',
    weekly: 'Woechentlich',
    monthly: 'Monatlich',
    quarterly: 'Vierteljaehrlich',
    onDemand: 'Bei Bedarf',
    subscriptionPlan: 'Abonnementplan',
    subscriptionHint: 'Wahlen Sie Ihre Stufe basierend auf der erwarteten Gruppengroesse.',
    subscriptionTier: 'Abonnementstufe',
    tierAutoUpgrade: 'Automatisches Upgrade bei Ueberschreitung der Mitgliedergrenze',
    billingCycle: 'Abrechnungszyklus',
    billedMonthly: 'Monatlich abgerechnet',
    annual: 'Jaehrlich',
    save10: '10% sparen',
    bestValue: 'Bester Wert',
    paymentMethod: 'Zahlungsmethode',
    creditCard: 'Kredit-/Debitkarte',
    bankAccount: 'US-Bankkonto',
    createGroup: 'Gruppe erstellen & Zahlung einrichten',
    members: 'Mitglieder',
  },
};

export function t(lang, key) {
  return translations[lang]?.[key] || translations.en[key] || key;
}
